// Rótulos de rol del CMS.
// Los tags de rol iban en azul/verde/oro, colores que la paleta de marca
// sustituye: el rol es identidad, no estado, así que comparte el tratamiento de
// los tags de sección (tinte #fdeceb sobre #a01a16). El propio rótulo distingue
// unos de otros; el color ya no tiene que hacerlo.
export const ROLE_LABELS = {
  super_admin: 'Super Admin',
  admin: 'Administrador',
  editor: 'Editor',
  camino: 'Camino',
};

export const getRoleLabel = (role) => ROLE_LABELS[role] || role || 'Sin rol';

export default getRoleLabel;
